import {
	getQueryParamsString,
	type OrderFilterDto,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { filteredUserIdAtom } from "Order/Atom/filteredUserIdAtom";
import { OrderPaths } from "Order/Routes/Routing";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";
import CustomFormLabel from "Shared/Components/Inputs/CustomFormLabel";
import {
	DEFAULT_PAGE_INDEX,
	DEFAULT_PAGE_LIMIT,
} from "Shared/Hooks/useTableFilter";
import { Stack, Switch } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";
import { useNavigate } from "react-router";

type Props = {
	filter: OrderFilterDto;
};

const orderResource = Resources.base.order.shared;

export const FilterCurrentUserSwitch: FC<Props> = ({ filter }) => {
	const [filteredUserId, setFilteredUserId] = useAtom(filteredUserIdAtom);
	const { t } = useResource();
	const navigate = useNavigate();
	const { user } = useUser();
	const currentUserOrdersFiltered = user?.id === filteredUserId;

	const handleChange = () => {
		const userIdToBeSet = currentUserOrdersFiltered ? null : (user?.id ?? null);
		setFilteredUserId(userIdToBeSet);
		navigate(
			`${OrderPaths.Index.path}${getQueryParamsString({ ...filter, unassignedUser: false, userId: userIdToBeSet, pageLimit: DEFAULT_PAGE_LIMIT, pageIndex: DEFAULT_PAGE_INDEX })}`,
		);
	};

	return (
		<Stack direction="row" alignItems="center">
			<CustomFormLabel sx={{ my: 0 }}>
				{t(orderResource.myOrders)}
			</CustomFormLabel>
			<Switch checked={!!currentUserOrdersFiltered} onChange={handleChange} />
		</Stack>
	);
};
